var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { generateQueryParamsStr } from "../../utils/apiUtils";
const GET_LATEST_UPDATES = 'api/updates/latest';
export const getLatestUpdates = function (params, options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` },
                signal: (options === null || options === void 0 ? void 0 : options.signal) || (params === null || params === void 0 ? void 0 : params.signal) || undefined
            };
            const queryParams = generateQueryParamsStr(['limit'], params || {});
            const url = queryParams ? `${GET_LATEST_UPDATES}?${queryParams}` : GET_LATEST_UPDATES;
            return yield this.axiosInstance.get(url, config);
        }
        catch (error) {
            if (error instanceof Error && (error.name === 'AbortError' || error.name === 'CanceledError')) {
                console.log('Request was cancelled');
                throw error;
            }
            console.error('Washday SDK - Error fetching latest updates:', error);
            throw error;
        }
    });
};
